import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/AuthContext";
import CandidateApp from "@/candidate/CandidateApp";
import SharedReport from "@/report/SharedReport";

const ConsoleRoutes = lazy(() => import("@/console/ConsoleRoutes"));

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center text-sm text-[#6E625C] bg-[#FBF8F5]">
    Loading console…
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/a/:token" element={<CandidateApp />} />
        <Route path="/r/:token" element={<SharedReport />} />
        <Route
          path="/console/*"
          element={
            <AuthProvider>
              <Suspense fallback={<Loading />}>
                <ConsoleRoutes />
              </Suspense>
            </AuthProvider>
          }
        />
        <Route path="*" element={<Navigate to="/console" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
